import complianceDocumentIcon from 'assets/launchpad/icons/compliance-document.png';
import dataTrendsIcon from 'assets/launchpad/icons/data-trends.png';
import decisionFlowIcon from 'assets/launchpad/icons/decision-flow.png';
import financialRiskRoiIcon from 'assets/launchpad/icons/financial-risk-roi.png';
import healthTechEcgIcon from 'assets/launchpad/icons/health-tech-ecg.png';
import inboundConsolidationIcon from 'assets/launchpad/icons/inbound-consolidation.png';
import layersIcon from 'assets/launchpad/icons/layers.png';
import monitoringRadarIcon from 'assets/launchpad/icons/monitoring-radar.png';
import networkAiIcon from 'assets/launchpad/icons/network-ai.png';
import outboundDistributionIcon from 'assets/launchpad/icons/outbound-distribution.png';
import routeTrackingIcon from 'assets/launchpad/icons/route-tracking.png';
import structurePyramidIcon from 'assets/launchpad/icons/structure-pyramid.png';
import supplyChainNodeIcon from 'assets/launchpad/icons/supply-chain-node.png';
import sustainabilityIcon from 'assets/launchpad/icons/sustainability.png';
import systemHealthIcon from 'assets/launchpad/icons/system-health.png';

import type { TLaunchpadIconKey } from './interfaces/ILaunchpadLane';

export const LAUNCHPAD_ICON_MAP: Record<TLaunchpadIconKey, string> = {
  'route-tracking': routeTrackingIcon,
  'network-ai': networkAiIcon,
  'inbound-consolidation': inboundConsolidationIcon,
  'financial-risk-roi': financialRiskRoiIcon,
  'system-health': systemHealthIcon,
  'structure-pyramid': structurePyramidIcon,
  'compliance-document': complianceDocumentIcon,
  sustainability: sustainabilityIcon,
  'decision-flow': decisionFlowIcon,
  'data-trends': dataTrendsIcon,
  'monitoring-radar': monitoringRadarIcon,
  'outbound-distribution': outboundDistributionIcon,
  'supply-chain-node': supplyChainNodeIcon,
  layers: layersIcon,
  'health-tech-ecg': healthTechEcgIcon,
};

export function getLaunchpadIconSrc(iconKey: TLaunchpadIconKey): string {
  return LAUNCHPAD_ICON_MAP[iconKey];
}
